module.exports = __webpack_public_path__ + "img/538-42dfb3.png";